export default __webpack_public_path__ + "static/media/exclamation.562cf15d.svg";